const videoEnhancer = {
  HitPawOnlineAIVideoEnhance: 'HitPaw Online AI Video Enhance',
  ProcessingLimit: 'Processing limit:{{num}}',
  AllModelsAreAvailable: 'All models are available',
  SupportAllSubdivisionRateExport: 'Support export of all resolution',
  SupportPreviewVideo: 'Support previewing video',
  BatchProcessingComingSoon: 'Batch processing (coming soon)',
  CancelAnytime: 'Cancel subscription anytime',
  highPriorityProcessingSpeed: 'High priority processing speed',
  YearDayPrice: 'R$2,44',
  YearTotalPrice: 'R$889,99',
  MonthTotalPrice: 'R$129,99',
  MonthDayPrice: 'R$4,33',
  WeekTotalPrice: 'R$49,99',
  WeekDayPrice: 'R$7,14',
  Day: 'Dia',
  Monthly: 'Mensalmente',
  Weekly: 'Semanalmente',
  Yearly: 'Anualmente',
};

export default videoEnhancer;
